export default __webpack_public_path__ + "static/media/Honored Boots of the Greensward.bb574b32.jpg";